/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { borderColor, borderWidth, size } from 'polished';

type Props = {
  arrow?: 'topleft' | 'topright',
  children: React$Element<*>
};

const defaultProps = {
  arrow: 'topleft'
};

const LegendWrapper = styled.div(({ arrow, theme }) => ({
  backgroundColor: theme.color.basis5,
  color: theme.color.basis2,
  fontSize: '0.8em',
  overflow: 'hidden', // necessary for animations
  position: 'relative',

  '&::after': {
    ...borderColor('transparent', 'transparent', theme.color.basis3),
    borderStyle: 'solid',
    ...borderWidth(0, 8, 8),
    bottom: '100%',
    content: '"\\00a0"',
    left: arrow === 'topleft' ? 8 : 'auto',
    position: 'absolute',
    right: arrow === 'topright' ? 8 : 'auto',
    ...size(0)
  }
}));

const LegendList = styled.ul({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  listStyle: 'none',
  margin: 0,
  overflowX: 'auto',
  padding: '0.25em 0'
});

function Legend({ arrow, children }: Props) {
  const validChildren = React.Children.toArray(children).filter(React.isValidElement);

  if (validChildren.length === 0) {
    return null;
  }

  return (
    <LegendWrapper arrow={arrow}>
      <LegendList>
        {validChildren.map(child => React.cloneElement(child, { component: 'li' }))}
      </LegendList>
    </LegendWrapper>
  );
}

Legend.defaultProps = defaultProps;

export default Legend;
